import script from "./InstructionSalesDrivePage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionSalesDrivePage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionSalesDrivePage.vue?vue&type=style&index=0&id=b3d60df4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3d60df4"]])

export default __exports__